export class MessageInfo {
    severity: string;
    summary: string;
    detail: string;
    duration?: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/message-info-model.ts